module.exports = __webpack_public_path__ + "static/image/sustainability/m/image_compliance.ver2_0_2.jpg?3e59d7f9";